import { base } from './';

const login = (data: { username: string; password: string }) =>
  base.post('/login', data);

export { login };
